<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Sign in required</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              Redirecting you to the portal to authenticate&hellip;

              You will be redirected in 5 seconds
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary">Sign in</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: "Login",

    mounted() {
      this.redirectIn({seconds: 5, to: '/auth/saml/redirect'});
    },
    methods: {
      ...mapActions(['redirectIn']),
    }
  }
</script>

<style scoped>

</style>
